import { lazy } from 'react';

const FavoritesListModal = lazy(() =>
  import('./pages/FinalList/components/modal/FavoritesListModal'),
);

const SchoolAddModal = lazy(() =>
  import('./pages/FinalList/components/modal/SchoolAddModalContainer'),
);

export default {
  FAVORITES_LIST_MODAL: FavoritesListModal,
  FINAL_LIST_ADD_SCHOOL_MODAL: SchoolAddModal,
};
